<template lang="pug">
  .b-spec-bulk-panel(data-testid="spec-bulk-panel")
    ._count Выбрано позиций: {{ count }}
    select._select(data-testid="spec-bulk-move-category" v-model="category" @change="onCategory")
      option(value="") переместить в категорию
      option(v-for="(title, code) in CATEGORIES" :key="code" :value="code") {{ title }}
    select._select(data-testid="spec-bulk-set-room" v-model="room" @change="onRoom")
      option(value="") привязать к помещению
      option(value="__none__") — снять привязку —
      option(v-for="value in rooms" :key="value" :value="value") {{ value }}
    button._action(type="button" data-testid="spec-bulk-request" @click="$emit('request')") запросить КП
    button._action(type="button" data-testid="spec-bulk-auto-choose" @click="$emit('auto-choose')") выбрать отклики
    button._action(type="button" data-testid="spec-bulk-budget" @click="$emit('budget')") плановый бюджет
    button._action(type="button" data-testid="spec-bulk-find-photos" @click="$emit('find-photos')") найти фото
    button._action.danger(type="button" data-testid="spec-bulk-delete" @click="$emit('delete')") удалить
</template>

<script>
import { CATEGORIES } from '@/utils/spec';

/**
 * Панель массовых действий: появляется при отмеченных строках (ТЗ 6.2). Сама ничего не делает —
 * выбор действия уходит странице, там же подтверждение удаления. Сгенерировано Claude.
 */
export default {
  name: 'SpecBulkPanel',
  props: {
    count: { type: Number, default: 0 },
    rooms: { type: Array, default: () => [] },
  },
  data() {
    return { CATEGORIES, category: '', room: '' };
  },
  methods: {
    onCategory() {
      const { category } = this;
      this.category = '';
      if (category) this.$emit('move-category', category);
    },
    onRoom() {
      const { room } = this;
      this.room = '';
      if (!room) return;
      this.$emit('set-room', room === '__none__' ? null : room);
    },
  },
};
</script>

<style scoped lang="scss">
.spec-bulk-panel {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 10px 16px;
  margin-bottom: 12px;
  border-radius: 8px;
  background: var(--color-dark-gray);
  color: var(--color-white);
  font-size: 13px;

  &__select {
    padding: 4px 6px;
    border: none;
    border-radius: 6px;
    font: inherit;
    font-size: 12px;
  }

  &__action {
    border: none;
    background: none;
    font: inherit;
    color: var(--color-white);
    text-decoration: underline;
    cursor: pointer;
    padding: 0;

    &.danger {
      color: #FFB1B1;
    }
  }
}
</style>
